module.exports = __webpack_public_path__ + "static/media/gopomoText.de61ef07.svg";